module.exports = __webpack_public_path__ + "createPreset.e987ac36f267812c552d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/createPreset.svg
// module id = ./src/assets/img/createPreset.svg
// module chunks = main